var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "d-inline-flex text-mono",
      attrs: { "data-comp": "Countdown" },
    },
    [
      _c("span", { attrs: { "data-part": "digit" } }, [
        _vm._v(_vm._s(_vm._f("two_digits")(_vm.hours))),
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-part": "separator" } }, [_vm._v(":")]),
      _vm._v(" "),
      _c("span", { attrs: { "data-part": "digit" } }, [
        _vm._v(_vm._s(_vm._f("two_digits")(_vm.minutes))),
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-part": "separator" } }, [_vm._v(":")]),
      _vm._v(" "),
      _c("span", { attrs: { "data-part": "digit" } }, [
        _vm._v(_vm._s(_vm._f("two_digits")(_vm.seconds))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }